import axios from 'axios';

// Get the current hostname to preserve subdomain context
const getApiUrl = () => {
  const hostname = window.location.hostname;
  const port = '3001'; // Backend port
  
  // If running on a .life domain (e.g., tunnels), use host from env
  if (hostname.endsWith('.life')) {
    // Prefer explicit env override; fallback to same host (https)
    return process.env.REACT_APP_API_URL || `https://${hostname}`;
  }

  // If we're on a subdomain, use api.{subdomain}.lvh.me pattern
  if (hostname.includes('lvh.me')) {
    const parts = hostname.split('.');
    if (parts.length >= 2) {
      const subdomain = parts[0]; // tearoom, sexymood, etc.
      return `http://api.${subdomain}.lvh.me:${port}`;
    }
  }
  
  // Fallback to environment variable
  return process.env.REACT_APP_API_URL || `http://localhost:${port}`;
};

const instance = axios.create({
  baseURL: 'http://localhost:3001', // Default, will be overridden
});

// Add a request interceptor to dynamically set the baseURL
instance.interceptors.request.use((config) => {
  // Dynamically set the baseURL for each request
  config.baseURL = getApiUrl();
  
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Add a response interceptor
instance.interceptors.response.use((response) => {
  return response;
}, (error) => {
  // Don't redirect on 401 errors - let components handle login failures
  // Only clear token if it's an authenticated request (not a login attempt)
  if (error.response && error.response.status === 401) {
    // Check if this is a login/sign_in request - don't clear token or redirect
    const isLoginRequest = error.config && error.config.url && error.config.url.includes('/sign_in');
    if (!isLoginRequest) {
      localStorage.removeItem('authToken');
      // Don't redirect to /login - there's no such route, login is handled via popup
    }
  }
  return Promise.reject(error);
});

export default instance;
